import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsDepartment from 'graphql/fields/FieldsDepartment'

const fields = {
	'guid': 'String',
	'name': 'String!',
	'active': 'String!',
};

export default gql(`
	mutation jobtitle( ${ HelperGraphql.createFields( fields ) } ) {
	    jobtitle( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsDepartment}
	    }
	}
`);

